import openNavigationExtension from './open-navigation-extension';

export default {
  openNavigationExtension,
};
